var React = require('react');

function Heart (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M71.29 55.304c-2.239-9.684-4.727-19.617-6.468-29.798-.747-5.215-.747-10.678.497-15.893C67.31.674 75.768-2.555 83.481 2.164c3.732 2.483 7.215 5.711 10.2 9.187 9.703 10.678 15.425 23.839 20.899 36.752 8.21 19.369 16.171 38.986 23.635 58.604 2.239 5.463 3.483 11.671 3.732 17.631.497 5.959-2.488 8.442-8.459 7.449-10.45-1.738-21.148-3.476-31.348-6.456-19.903-5.712-39.558-12.913-57.47-23.342-15.923-9.188-29.358-21.108-39.309-36.504-1.742-2.483-2.986-5.463-3.981-8.194-5.225-14.899 4.976-27.067 20.65-25.081 9.205 1.242 17.664 4.967 25.874 9.437 8.459 4.718 16.171 9.436 23.386 13.657z"}));
}

Heart.defaultProps = {"viewBox":"0 0 143 132"};

module.exports = Heart;

Heart.default = Heart;
